export const DEFAULT_PAGE_SIZE = 30;
export const PAGE_SIZE_OPTIONS = [10, 20, 25, 30, 50, 100];

export const LOCAL_STORAGE_TABLE_PREFIX = 'widgets-table';
